import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'mermas',
})
export class MermasPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (items) {

      if (filter['id_local']) {
        items = items.filter((item) => item.id_local == filter['id_local']);
      }

      if (filter['id_ubicacion']) {
        items = items.filter((item) => item.id_ubicacion == filter['id_ubicacion']);
      }

      if (filter['id_tipo']) {
        items = items.filter((item) => item.id_tipo == filter['id_tipo']);
      }

      return items;

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/mermas/mermas.ts